module.exports = __webpack_public_path__ + "static/NotoSans-ExtraBold-d5a76e63d7b5a41ce23753cc3ee608e6.woff2";